import { useTheme } from '@mint-lib/styled';
import type {} from '@mint-lib/theme/src/extensions/palette.js';

import { ChannelTypeCategory, ChannelTypes } from '@myn/shared/src/constants';

export const useChannels = () => {
  const theme = useTheme();

  return {
    [ChannelTypes.DISPLAY]: {
      name: 'Display',
      icon: 'ChannelDisplay' as const,
      color: theme.palette.channel.display,
      backgroundColor: theme.palette.channel.displayBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.AD_SERVER]: {
      name: 'Adserver',
      icon: 'ChannelAdserver' as const,
      color: theme.palette.channel.adserver,
      backgroundColor: theme.palette.channel.adserverBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.SEARCH]: {
      name: 'Search',
      icon: 'ChannelSearch' as const,
      color: theme.palette.channel.search,
      backgroundColor: theme.palette.channel.searchBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.NATIVE]: {
      name: 'Native',
      icon: 'ChannelNative' as const,
      color: theme.palette.channel.native,
      backgroundColor: theme.palette.channel.nativeBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.SOCIAL]: {
      name: 'Social',
      icon: 'ChannelSocial' as const,
      color: theme.palette.channel.social,
      backgroundColor: theme.palette.channel.socialBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.ADDRESSABLE_TV]: {
      name: 'Addressable TV',
      icon: 'ChannelAddressableTv' as const,
      color: theme.palette.channel.addressableTV,
      backgroundColor: theme.palette.channel.addressableTVBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.VIDEO]: {
      name: 'Video',
      icon: 'ChannelVideo' as const,
      color: theme.palette.channel.video,
      backgroundColor: theme.palette.channel.videoBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.OFFLINE_TV]: {
      name: 'Offline TV',
      icon: 'ChannelOfflineTv' as const,
      color: theme.palette.channel.offlineTV,
      backgroundColor: theme.palette.channel.offlineTVBackground,
      type: ChannelTypeCategory.offline,
    },
    [ChannelTypes.DOOH]: {
      name: 'DOOH',
      icon: 'ChannelDooh' as const,
      color: theme.palette.channel.dooh,
      backgroundColor: theme.palette.channel.doohBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.OOH]: {
      name: 'Ooh',
      icon: 'ChannelOoh' as const,
      color: theme.palette.channel.ooh,
      backgroundColor: theme.palette.channel.oohBackground,
      type: ChannelTypeCategory.offline,
    },
    [ChannelTypes.DMP]: {
      name: 'DMP',
      icon: 'ChannelDmp' as const,
      color: theme.palette.channel.dmp,
      backgroundColor: theme.palette.channel.dmpBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.DEM]: {
      name: 'Dem',
      icon: 'ChannelDem' as const,
      color: theme.palette.channel.dem,
      backgroundColor: theme.palette.channel.demBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.MOBILE]: {
      name: 'Mobile',
      icon: 'ChannelMobile' as const,
      color: theme.palette.channel.mobile,
      backgroundColor: theme.palette.channel.mobileBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.PUBLISHER]: {
      name: 'Publisher',
      icon: 'ChannelPublisher' as const,
      color: theme.palette.channel.publisher,
      backgroundColor: theme.palette.channel.publisherBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.OFFLINE_RADIO]: {
      name: 'Offline radio',
      icon: 'ChannelOfflineRadio' as const,
      color: theme.palette.channel.offlineRadio,
      backgroundColor: theme.palette.channel.offlineRadioBackground,
      type: ChannelTypeCategory.offline,
    },
    [ChannelTypes.NETWORK]: {
      name: 'Network',
      icon: 'ChannelNetwork' as const,
      color: theme.palette.channel.network,
      backgroundColor: theme.palette.channel.networkBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.PROGRAMMATIC_RADIO]: {
      name: 'Programmatic radio',
      icon: 'ChannelProgrammaticRadio' as const,
      color: theme.palette.channel.programmaticRadio,
      backgroundColor: theme.palette.channel.programmaticRadioBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.DIRECT]: {
      name: 'Direct',
      icon: 'ChannelDirect' as const,
      color: theme.palette.channel.direct,
      backgroundColor: theme.palette.channel.directBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.BRAND_SAFETY]: {
      name: 'Brand safety',
      icon: 'ChannelBrandSafety' as const,
      color: theme.palette.channel.brandSafety,
      backgroundColor: theme.palette.channel.brandSafetyBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.CHAT_BOT]: {
      name: 'Chat bot',
      icon: 'ChannelChatBot' as const,
      color: theme.palette.channel.chatBot,
      backgroundColor: theme.palette.channel.chatBotBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.DSP]: {
      name: 'DSP',
      icon: 'ChannelDsp' as const,
      color: theme.palette.channel.dsp,
      backgroundColor: theme.palette.channel.dspBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.INFLUENCER_MARKETING]: {
      name: 'Influencer marketing',
      icon: 'ChannelInfluencerMarketing' as const,
      color: theme.palette.channel.influencerMarketing,
      backgroundColor: theme.palette.channel.influencerMarketingBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.BRANDED_CONTENT]: {
      name: 'Branded content',
      icon: 'ChannelBrandedContent' as const,
      color: theme.palette.channel.brandedContent,
      backgroundColor: theme.palette.channel.brandedContentBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.WEB_ANALYTICS]: {
      name: 'Web Analytics',
      icon: 'ChannelWebAnalytics' as const,
      color: theme.palette.channel.webAnalytics,
      backgroundColor: theme.palette.channel.webAnalyticsBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.ORGANIC]: {
      name: 'Organic',
      icon: 'ChannelPublisher' as const,
      color: theme.palette.channel.organic,
      backgroundColor: theme.palette.channel.organicBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.AFFILIATION]: {
      name: 'Affiliation',
      icon: 'ChannelAffiliation' as const,
      color: theme.palette.channel.affiliation,
      backgroundColor: theme.palette.channel.affiliationBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.META_SEARCH]: {
      name: 'MetaSearch',
      icon: 'ChannelMetasearch' as const,
      color: theme.palette.channel.metasearch,
      backgroundColor: theme.palette.channel.metasearchBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.PAY_TV]: {
      name: 'Pay TV',
      icon: 'ChannelPayTv' as const,
      color: theme.palette.channel.payTV,
      backgroundColor: theme.palette.channel.payTVBackground,
      type: ChannelTypeCategory.offline,
    },
    [ChannelTypes.PROMOCODE]: {
      name: 'Promocode',
      icon: 'ChannelPromocode' as const,
      color: theme.palette.channel.promocode,
      backgroundColor: theme.palette.channel.promocodeBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.MEMBER_GET_MEMBER]: {
      name: 'MemberGetMember',
      icon: 'ChannelMgm' as const,
      color: theme.palette.channel.mgm,
      backgroundColor: theme.palette.channel.mgmBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.EVENTS]: {
      name: 'Events',
      icon: 'ChannelEvents' as const,
      color: theme.palette.channel.webAnalytics,
      backgroundColor: theme.palette.channel.webAnalyticsBackground,
      type: ChannelTypeCategory.offline,
    },
    [ChannelTypes.NEWSPAPER]: {
      name: 'Newspaper',
      icon: 'ChannelNewspaper' as const,
      color: theme.palette.channel.newspaper,
      backgroundColor: theme.palette.channel.newspaperBackground,
      type: ChannelTypeCategory.offline,
    },
    [ChannelTypes.MAGAZINE]: {
      name: 'Magazine',
      icon: 'ChannelMagazine' as const,
      color: theme.palette.channel.magazine,
      backgroundColor: theme.palette.channel.magazineBackground,
      type: ChannelTypeCategory.offline,
    },
    [ChannelTypes.CINEMA]: {
      name: 'Cinema',
      icon: 'ChannelCinema' as const,
      color: theme.palette.channel.cinema,
      backgroundColor: theme.palette.channel.cinemaBackground,
      type: ChannelTypeCategory.offline,
    },
    [ChannelTypes.DIRECT_MEDIA]: {
      name: 'Direct Media',
      icon: 'ChannelDirectMedia' as const,
      color: theme.palette.channel.directMedia,
      backgroundColor: theme.palette.channel.directMediaBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.PAID_PROGRAMMATIC]: {
      name: 'Paid Programmatic',
      icon: 'ChannelPaidProgrammatic' as const,
      color: theme.palette.channel.paidProgrammatic,
      backgroundColor: theme.palette.channel.paidProgrammaticBackground,
      type: ChannelTypeCategory.online,
    },
    [ChannelTypes.RETAIL]: {
      name: 'Retail',
      icon: 'ChannelRetail' as const,
      color: theme.palette.channel.retail,
      backgroundColor: theme.palette.channel.retailBackground,
      type: ChannelTypeCategory.online,
    },
  };
};
